<template>
    <div 
        class="draggable-event" 
        :style="dragStyles" 
        v-if="isDragging" 
    >
        <Event 
            v-bind="event"
            :date="newDate || event.date"
        />
    </div>
</template>

<script>
    import { event } from 'vue-analytics';
import Event from './Event.vue'
    export default {

        components: {
            Event,
        },

        props: {
            eventId: String,
            event: Object,
            e: MouseEvent,
            el: HTMLElement,

            // L'élément survolé actuellement (passé par le parent)
            magneticElement: {
                type: HTMLElement,
                default: null
            }
        },

        mounted () {
        },

        data() {
            return {
                isDragging: false,
                dragStyles: {},
                initialMouseOffset: { x: 0, y: 0 },
                initialPosition: { x: 0, y: 0},
                newDate: null,
            }
        },
   
        methods: {
            handleMouseDown(e) {
                console.log('handleMouseDown draggable', e, this.el);
                const rect = this.el.getBoundingClientRect();
                
                // On calcule où l'utilisateur a cliqué à l'intérieur de la carte
                this.initialMouseOffset = {
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top
                };
                this.initialPosition = {
                    x: rect.left,
                    y: rect.top
                };

                // On fixe la largeur pour que la carte ne change pas de taille en sortant du flux
                this.dragStyles = {
                    width: `${rect.width}px`,
                    height: `${rect.height}px`,
                    position: 'fixed',
                    zIndex: 1000,
                    pointerEvents: 'none', // Pour pouvoir survoler les éléments en dessous
                    top: `${rect.top}px`,
                    left: `${rect.left}px`
                };

                this.isDragging = true;

                window.addEventListener('mousemove', this.handleMouseMove);
                window.addEventListener('mouseup', this.handleMouseUp);

            },

            handleMouseMove(e) {
                if (!this.isDragging) return;
                
                // Mise à jour de la position selon la souris
                this.dragStyles.top = `${e.clientY - this.initialMouseOffset.y}px`;
                this.dragStyles.left = `${e.clientX - this.initialMouseOffset.x}px`;


                const elementUnder = document.elementFromPoint(e.clientX, e.clientY);
                const magneticZone = elementUnder?.closest('[drag-event-magnetic="true"]');

                if (magneticZone) {
                    const mRect = magneticZone.getBoundingClientRect();
                    this.dragStyles.top = `${mRect.top}px`;
                    this.dragStyles.left = `${mRect.left}px`;
                    this.dragStyles.width = `${mRect.width}px`;
                    
                    
                    const hours = magneticZone.getAttribute('data-drag-event-hours');
                    const minutes = magneticZone.getAttribute('data-drag-event-minutes');
                    
                    if (hours !== null || minutes !== null) {
                        const newDate = new Date(this.event.date);
                        if (hours !== null) newDate.setHours(parseInt(hours));
                        if (minutes !== null) newDate.setMinutes(parseInt(minutes));
                        this.newDate = newDate;
                    }else{
                        this.newDate = null;
                    }
                  
                    
                }else{
                    this.dragStyles.top = `${e.clientY - this.initialMouseOffset.y}px`;
                    this.dragStyles.left = `${e.clientX - this.initialMouseOffset.x}px`;
                    this.newDate = null;
                }
                console.log('magneticZone', magneticZone);
        },

            handleMouseUp(e) {
                window.removeEventListener('mousemove', this.handleMouseMove);
                window.removeEventListener('mouseup', this.handleMouseUp);

               
                const elementUnder = document.elementFromPoint(e.clientX, e.clientY);
                const elLocation = elementUnder?.closest('[data-drag-event-location]');
                console.log('elLocation', elLocation);
                if (elLocation) {
                    this.isDragging = false;
                    this.dragStyles = {};
                   
                    const location = elLocation.getAttribute('data-drag-event-location');
                    this.$emit('eventDragStop', {location_id: location});
                }else{
                    this.animateReturn();
                }
            },

            animateReturn() {
                this.isReturning = true;

                this.dragStyles = {
                    ...this.dragStyles,
                    top: `${this.initialPosition.y}px`,
                    left: `${this.initialPosition.x}px`,
                    transition: 'all 0.3s ease-in-out'
                };

                setTimeout(() => {
                    this.isDragging = false;
                    this.isReturning = false;
                    this.dragStyles = {};

                    this.$emit('eventDragStop', { 
                        id: null, 
                        eventId: this.id,
                    });
                }, 300);
            }
        },

        watch: {
            e(newValue, oldValue) {
                if (newValue) this.handleMouseDown(newValue);
            }
        },

        destroyed () {
            window.removeEventListener('mousemove', this.handleMouseMove);
            window.removeEventListener('mouseup', this.handleMouseUp);
        },
    }



</script>

<style lang="scss" scoped>
    .draggable-event {
        position: fixed,
    }
</style>